module.exports = __webpack_public_path__ + "img/geofence-white-pin.3d92cf98.svg";